<template>
  <div id="app" class="page-wrapper">
    <NavBarHeader v-if="user" v-bind="{user, logout}"></NavBarHeader>
    <SideBarNav v-if="user" v-bind="{user, version, logout}"></SideBarNav>
  </div>
</template>


<script>
//bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Bootstrap from "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import Carbon from "../node_modules/carbon-admin/dist/js/carbon.js";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Mgr from "@/services/SecurityService";
import UserService from "@/components/general/UserService.vue";
import NavBarHeader from "@/components/general/NavBarHeader.vue";
import SideBarNav from "@/components/general/SideBarNav.vue";
//dev express
import "devextreme/dist/css/dx.common.css";
// import "devextreme/dist/css/dx.material.lime.light.css";
import './styles/dx.material.NowMicroTheme.css'
  // import "./styles/dx.material.custom-scheme.css"


export default {
  name: "App",
  components: {
    UserService,
    NavBarHeader,
    SideBarNav
  },
  data() {
    return {
      mgr: new Mgr(),
      signedIn: false,
      user: null
    };
  },
  computed: {
    version: function() {
      return process.env.VUE_APP_VERSION;
    }
  },

  created() {
    document.title = process.env.VUE_APP_TITLE;
    this.detectMSIE();
  },
  mounted() {
    this.mgr.getUser().then(
      data => {
        this.user = data;
      },
      err => {
        console.log(err);
      }
    );
  },
  methods: {
    login: function() {
      this.mgr.getSignedIn().then(
        success => {
          this.signedIn = success;
        },
        err => {
          console.log(err);
        }
      );
    },

    logout: function() {
      this.mgr.signOut().then(
        success => {
          this.signedIn = success;
        },
        err => {
          console.log(err);
        }
      );
    },
    detectMSIE() {
      var isIE =
        !!navigator.userAgent.match(/Trident/g) ||
        !!navigator.userAgent.match(/MSIE/g);

      if (isIE) {
        var x = document.getElementById("app");
        x.innerHTML = "<h1>IE is not supported</h1>";
      }
    }
  }
};
</script>

<style lang="scss">
$simple-line-font-path: "../node_modules/simple-line-icons/fonts/" !default;

@import "../node_modules/simple-line-icons/scss/simple-line-icons.scss";
@import "@/styles/custom.scss";
</style>
